import logo from "../../assets/logos/logoX.png";
import user from "../../assets/icons/user.svg";
import deco from "../../assets/icons/logout.svg";
import { useTokenContext } from "../../context/tokenContext";
import useModal from "../../hooks/useModal";
import ModalDeconnexion from "./ModalDeconnexion";
import { useNavigate } from "react-router-dom";
import { showToastError } from "../../services/Toasts/toasts";
import { downloadPatchnote } from "../../services/Api/patchnote";
import { useTranslation } from "react-i18next";
import fr from "../../assets/images/france.png";
import en from "../../assets/images/royaume-uni.png";

const Header = () => {
  const { firstname, lastname } = useTokenContext();
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isFrench = (i18n.resolvedLanguage || i18n.language).startsWith("fr");

  const handlePatchnote = () => {
    downloadPatchnote()
      .then((response) => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          const url = URL.createObjectURL(response.data);
          window.open(url, "_blank");
        };
        fileReader.readAsBinaryString(response.data);
      })
      .catch(() =>
        showToastError("Erreur lors du téléchargement du patchnote"),
      );
  };

  return (
    <header className="z-50 flex h-14 w-full flex-shrink-0 items-center justify-between bg-dark-lavender px-2 py-2 sm:px-4">
      {isModalOpen ? modalContent : null}
      <div className="flex min-w-0 items-center gap-2 sm:gap-4">
        <img src={logo} alt="logo Nexum" className="ml-1 h-8 w-6 flex-shrink-0 sm:ml-2" />
        {/* Patchnote */}
        <button
          className="group relative ml-2 hidden cursor-pointer items-center gap-3 rounded-xl border border-white/30 bg-white/95 px-3 py-1 shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-white hover:shadow-xl sm:flex lg:ml-10 lg:px-4"
          onClick={() => handlePatchnote()}
        >
          <p className="text-xl">💡</p>
          <span className="text-dark-lavender font-medium font-K2D text-sm whitespace-nowrap">
            Patchnote
          </span>
          <div className="hidden sm:block w-2 h-2 bg-dark-lavender/60 rounded-full group-hover:bg-dark-lavender transition-colors duration-300"></div>
        </button>
      </div>
      <div className="flex min-w-0 items-center gap-1.5 sm:gap-3 lg:gap-4">
        {/* Langue */}
        <button
          className="group relative flex cursor-pointer items-center gap-2 rounded-xl border border-white/30 bg-white/95 p-2 shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-white hover:shadow-xl md:px-4"
          onClick={() => i18n.changeLanguage(isFrench ? "en" : "fr")}
        >
          {isFrench ? (
            <img
              src={en}
              alt="icon en"
              className="h-5 w-5 text-dark-lavender transition-transform duration-300 group-hover:scale-110"
            />
          ) : (
            <img
              src={fr}
              alt="icon fr"
              className="h-5 w-5 text-dark-lavender transition-transform duration-300 group-hover:scale-110"
            />
          )}
          <span className="hidden whitespace-nowrap font-K2D text-sm font-medium text-dark-lavender md:inline">
            {isFrench ? "English" : "Français"}
          </span>
        </button>
        {/* Profil */}
        <button
          className="group relative flex cursor-pointer items-center gap-2 rounded-xl border border-white/30 bg-white/95 p-2 shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-white hover:shadow-xl lg:px-4"
          onClick={() => navigate("/profil")}
        >
          <div className="relative">
            <img
              src={user}
              alt="icon user"
              className="h-5 w-5 text-dark-lavender transition-transform duration-300 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-dark-lavender/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-150"></div>
          </div>
          <span className="hidden max-w-40 truncate whitespace-nowrap font-K2D text-sm font-medium text-dark-lavender lg:inline">
            {firstname} - {lastname}
          </span>
          <div className="hidden sm:block w-2 h-2 bg-dark-lavender/60 rounded-full group-hover:bg-dark-lavender transition-colors duration-300"></div>
        </button>
        <button
          className="group relative flex cursor-pointer items-center rounded-xl border border-white/30 p-2 shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:bg-white hover:shadow-xl sm:mr-2 lg:mr-10 lg:px-4"
          onClick={() =>
            openModal(<ModalDeconnexion closeModal={closeModal} />)
          }
        >
          <div className="relative">
            <img
              src={deco}
              alt="icon déconnexion"
              className="h-5 w-5 text-dark-lavender transition-transform duration-300 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-dark-lavender/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-150"></div>
          </div>
        </button>
      </div>
    </header>
  );
};

export default Header;
